import { render, staticRenderFns } from "./JdSortButton.vue?vue&type=template&id=0051e834&scoped=true&"
import script from "./JdSortButton.vue?vue&type=script&lang=js&"
export * from "./JdSortButton.vue?vue&type=script&lang=js&"
import style0 from "./JdSortButton.vue?vue&type=style&index=0&id=0051e834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0051e834",
  null
  
)

export default component.exports